import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { TableCard } from '../../../../components/Table/TableCard'
import { extrairErrosProtocolo } from '../core/errosProtocolo'
import { ModeloLauduzCard } from './components/ModeloLauduzCard'
import { VersaoVigente } from './components/VersaoVigente'
import { ProtocolosTriagemListHeader } from './components/header/ProtocolosTriagemListHeader'
import { useVersoesProtocolo } from './core/useVersoesProtocolo'
import { ProtocolosTriagemTable } from './table/ProtocolosTriagemTable'

/** Lista das versões do protocolo da empresa (T7a AC1). */
export const ProtocolosTriagemList: FC = () => {
  const { error } = useVersoesProtocolo()

  if (error && extrairErrosProtocolo(error).status === 403) {
    return <Navigate to='/error/404' />
  }

  return (
    <>
      <VersaoVigente />
      <TableCard>
        <ProtocolosTriagemListHeader />
        <ProtocolosTriagemTable />
      </TableCard>
      <ModeloLauduzCard />
    </>
  )
}
